export default __webpack_public_path__ + "static/media/icon_messages.aae0de50.svg";